import React, { FC } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { RECAPTCHA_PUBLIC_KEY } from 'src/constants/vars'


// Define your higher-order component
const ReCaptchaProvider = <P extends object>(
    WrappedComponent: React.ComponentType<P>
) => {
    // Return a functional component
    const WithGoogleReCaptchaProvider: FC<P> = (props) => {
        // Render the GoogleReCaptchaProvider and pass down the props to the wrapped component
        return (
            <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_PUBLIC_KEY}>
                <WrappedComponent {...props} />
            </GoogleReCaptchaProvider>
        );
    };
    return WithGoogleReCaptchaProvider;
};


export default ReCaptchaProvider
